// extracted by mini-css-extract-plugin
export default {"container":"SuccessCheckout_container__EVozB","messageContainer":"SuccessCheckout_messageContainer__y+DtK","imageContainer":"SuccessCheckout_imageContainer__H6wcM"};